import React, { useCallback, useMemo } from 'react'
import debounce from 'lodash/debounce'

export const useDebouncedScroll = (handleFetchMoreData?: () => void, debounceTime = 100) => {
  const debouncedHandler = useMemo(
    () =>
      debounce(() => {
        if (handleFetchMoreData) {
          handleFetchMoreData()
        }
      }, debounceTime),
    [handleFetchMoreData, debounceTime]
  )

  return useCallback(
    (event: React.SyntheticEvent) => {
      const listboxNode = event.currentTarget
      if (listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 5) {
        debouncedHandler()
      }
    },
    [debouncedHandler]
  )
}
